<template>
  <div id="timeslot" class="main-wrapper">
    <div class="back-button" @click="changeState(-1)">
      <i class="anyteachicon anyteach-caret-square-left" />上一步
    </div>
    <div class="section-header">定制上课时间</div>
    <div class="select-wrapper">
      <h2 v-if="!daysOfClasses[0] && daysOfClasses[0] != 0">选择时间</h2>
      <h2 v-else>每周 {{ daysOfClasses.length }} 次 ✕ {{ duration }} 小时</h2>
      <div :key="index" v-for="(item, index) in timeslot" class="radio">
        <div
          :class="{ selected: item.isSelected }"
          class="radio-item-wrapper"
          @click="selectDay(index)"
        >
          <div class="radio-item">
            <div class="radio-item-left">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text">每{{ item.name }}</span>
            </div>
            <select @click.stop v-if="item.isSelected" v-model="item.time" class="radio-item-right">
              <option value selected disabled>请选择上课时间</option>
              <option :key="index" v-for="(item, index) in timeArr" :value="item"
                >{{ item }} - {{ timeArrMax[index + duration * 2] }}</option
              >
            </select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="daysOfClasses.length && timesSelected" class="action-button" @click="changeState()">
      下一步
    </div>
    <div v-else class="action-button button-disabled">下一步</div>
  </div>
</template>
<script>
export default {
  name: "Timeslot",
  props: ["data"],
  data() {
    return {
      weekdaysArr: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timeslot: {},
      daysOfClasses: [],
      timeArr: [
        "9:00",
        "9:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
      ],
      timeArrMax: [
        "9:00",
        "9:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00",
      ],
    }
  },
  watch: {
    daysOfClasses: function (val) {
      this.$emit("update", { daysOfClasses: this.daysOfClasses })
    },
    timeslot: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.updateTimeslot()
      }
    }
  },
  computed: {
    numOfClasses() {
      if (!this.data || !this.data.sessions) return 0
      return this.data.sessions.regular + this.data.sessions.extra
    },
    duration() {
      return this.data && this.data.duration ? this.data.duration : 0
    },
    timesSelected() {
      return Object.keys(this.timeslot).every(
        item =>
          !this.timeslot[item].isSelected ||
          (this.timeslot[item].isSelected && this.timeslot[item].time),
      )
    },
  },
  created() {
    for (let i = 0; i <= 6; i++) {
      this.timeslot[i] = {
        name: this.weekdaysArr[i],
        isSelected: false,
        time: "",
        timeEnd: "",
      }
    }
  },
  methods: {
    selectDay(index) {
      if (this.daysOfClasses.length === this.numOfClasses && !this.timeslot[index].isSelected) {
        this.$toast(`课时包只有 ${this.numOfClasses} 次`)
      } else {
        this.timeslot[index].isSelected = !this.timeslot[index].isSelected
        this.timeslot = JSON.parse(JSON.stringify(this.timeslot))
        this.$forceUpdate()
      }
      this.daysOfClasses = Object.keys(this.timeslot)
        .filter(item => this.timeslot[item].isSelected)
        .map(item => parseInt(item))
    },
    updateTimeslot() {
      for (const key in this.timeslot) {
        const value = this.timeslot[key]
        if (value.isSelected && value.time) {
          const maxKey = this.timeArrMax.indexOf(value.time) + this.duration * 2
          this.timeslot[key].timeEnd = this.timeArrMax[maxKey]
        }
      }
    },
    changeState(step = 1) {
      this.$emit("update", { timeslot: this.timeslot })
      this.$emit("state", step)
    }
  },
}
</script>
<style scoped lang="scss">
@import "../../../../static/css/prog-form.scss";
@import "../../../../static/css/radio.scss";

#timeslot {
  h2 {
    font-weight: 400;
  }
  .select-wrapper {
    border: none;
  }
  .radio {
    border-bottom: 1px solid #eee;
  }
  .radio-item-wrapper {
    width: 100%;
  }
  .radio-item {
    justify-content: space-between;
    width: 100%;
  }
  .radio-item-left {
    display: flex;
    width: 50%;
  }
  .radio-item-right {
    width: 50%;
    padding: 0;
  }
}
</style>
